// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__E84KJ","container":"SectionFaq_container__fSkZ5","faq__title":"SectionFaq_faq__title__8DWVt","faq__list-container":"SectionFaq_faq__list-container__kC35M"};